import { render, staticRenderFns } from "./MemberNotes.vue?vue&type=template&id=6941487a&scoped=true&"
import script from "./MemberNotes.vue?vue&type=script&lang=js&"
export * from "./MemberNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6941487a",
  null
  
)

export default component.exports